import React from "react";
import { Navbar, Container, Nav, Row, Col } from "react-bootstrap";
import Logo from "../assets/footer-logo-updated.svg";

const Footer = ({ lang }) => {
  return (
    <>
      <section className="bg-light-grey fifthPanel">
        <Container>
          <Row>
            <Col md={{ span: 12 }} lg={{ span: 4, offset: 1 }}>
              <h2>Desarrollado por</h2>
            </Col>
            <Col
              md={{ span: 12 }}
              lg={{ span: 5, offset: 1 }}
              className="d-flex"
            >
              <div className="d-flex justify-content-center align-items-center">
                <Logo />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Navbar className="footer">
        <Container>
          <Navbar.Brand className="brand logo" href="/">
            <span className="d-none d-sm-none d-md-none d-lg-block">
              Mental Health <em>Action</em> Day
            </span>
            <span className="d-block d-sm-block d-md-block d-lg-none">
              Mental Health
              <br />
              <em>Action</em> Day
            </span>
          </Navbar.Brand>
          <Nav className="mr-auto">
            <Nav.Link
              className="text-dark"
              href="mailto:Jay.Osterman@mtvstaff.com"
            >
              Contacto de prensa
            </Nav.Link>
            <Nav.Link
              className="text-dark"
              href="https://www.mtv.com/legal/o3ccr8/terms-of-use"
            >
              Condiciones generales
            </Nav.Link>
            <Nav.Link
              className="text-dark"
              target="_blank"
              href="https://www.viacomcbsprivacy.com/policy"
            >
              Política de privacidad
            </Nav.Link>
            <Nav.Link
              className="text-dark"
              target="_blank"
              href="https://privacy.paramount.com/en/policy#additional-information-us-states"
            >
              California Notice
            </Nav.Link>
            <Nav.Link
              className="text-dark ot-sdk-show-settings"
              href="https://www.viacomcbsprivacy.com/donotsell"
            >
              Sus opciones de privacidad
            </Nav.Link>
          </Nav>
          <Nav className="top-link">
            <Nav.Link className="text-dark " href="#top">
              Principio de página{" "}
              <span className="icomoon icon-arrow-up">&nbsp;</span>
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <Container>
        <Row>
          <Col>
            <p
              style={{
                fontSize: ".825rem",
                textAlign: "center",
                paddingTop: "16px",
                marginBottom: "0",
              }}
            >
              ©2021 Viacom International Inc. All rights reserved
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default Footer;
